import cookie from 'js-cookie';

export const setCookieItem = (key, value) => cookie.set(key, value);

export const getCookieItem = key => cookie.get(key);

export const removeCookieItem = key => cookie.remove(key);



// WEBPACK FOOTER //
// ./src/js/services/cookies.js